import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import TextArea from "../../../../../components/form/TextArea";

export default function AdditionalContextInput() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <TextArea
      label="Additional context"
      name="speakerAbout"
      value={values?.additionalContext ?? ""}
      tooltip="Add any additional information about the source or channel which will be helpful to the AI for content generation."
      placeholder="example: Jane Doe is speaking in a podcast about the importance of mental health in fitness."
      maxLength={500}
      maxHeight={150}
      showCharacterCount={true}
      onChange={({ target: { value } }) =>
        setFieldValue("additionalContext", value)
      }
      onBlur={({ target: { value } }) => {
        setFieldValue("additionalContext", value.trim());
      }}
    />
  );
}
